import Rete, { Socket} from "rete";
import VueControlX from "./ResetControl.vue";
import AnyTypeSocket from "../../Utils/CommonSockets";

export class ResetControl extends Rete.Control {
  constructor(emitter, key, sleepTime) {
    super(key);
    this.props = { emitter, ikey: key, sleepTime };
    this.render = "vue";
    this.component = VueControlX;
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}

const ResetSocket = new Socket("Reset.Socket");
ResetSocket.combineWith(AnyTypeSocket);
export { ResetSocket };